const serverErrorFieldName = {
  saveAndExitError: 'saveAndExitError',
};

const requiredFieldNames = {
  contactEmail: 'contactEmail',
  contactName: 'contactName',
  contactPhone: 'contactPhone',
  forRentBy: 'forRentBy',
  isApplicationsAccepted: 'isApplicationsAccepted',
  leaseDuration: 'leaseDuration',
};

const contactSectionRequiredFields = [
  requiredFieldNames.contactEmail,
  requiredFieldNames.contactName,
  requiredFieldNames.contactPhone,
  requiredFieldNames.forRentBy,
  requiredFieldNames.isApplicationsAccepted,
  requiredFieldNames.leaseDuration,
];

export { requiredFieldNames, contactSectionRequiredFields, serverErrorFieldName };
